import { userApi } from '@/api';

// ローカルストレージから認証状態を復元
const getStoredUser = () => {
  try {
    const storedUser = localStorage.getItem('user');
    return storedUser ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error('Failed to parse stored user:', error);
    localStorage.removeItem('user');
    return null;
  }
};

const state = {
  user: getStoredUser()
};

const getters = {
  isAuthenticated: state => !!state.user,
  stateUser: state => state.user,
  isAdmin: state => !!state.user?.roles?.some(
    role => ["システム管理者", "管理者ユーザー", "admin"].includes(role.role_name)
  )
};

const actions = {
  async register({ dispatch }, form) {
    await userApi.register(form)
    let UserForm = new FormData();
    UserForm.append('username', form.username);
    UserForm.append('password', form.password);
    await dispatch('logIn', UserForm);
  },
  // async logIn({ dispatch }, user) {
  //   await userApi.login(user);
  //   await dispatch('viewMe');
  // },
  async logIn({ dispatch }) {
    await dispatch('viewMe');
  },

  async logIn_forwriting({ dispatch }) {
    console.log('🔍 [STORE] logIn_forwriting() called');
    console.trace('🔍 [STORE] Call stack for logIn_forwriting');
    await dispatch('viewMe_forwriting');
  },

  async viewMe({ commit }) {
    try {
      let response = await userApi.whoami();
      await commit('setUser', response?.data ? response.data : null);
    } catch (err) {
      // Session may be expired; keep UI stable and treat as logged out.
      console.warn('viewMe fallback to logged-out state:', err?.response?.status || err);
      await commit('setUser', null);
    }
  },

  // todo: 在未登錄時這裡會調用 whoami() 導致錯誤
  // 暫時用 try catch 把錯誤藏起來，應該有更好的解法。
  async viewMe_forwriting({ commit }) {
    console.log('🔍 [STORE] viewMe_forwriting() called');
    console.trace('🔍 [STORE] Call stack for viewMe_forwriting');
    try {
      console.log('🔍 [STORE] Making whoami API call...');
      let response = await userApi.whoami()
      console.log('🔍 [STORE] whoami API response:', response?.data);
      await commit('setUser', response?.data ? response.data : null);
      console.log('✅ [STORE] User state updated successfully');
    }
    catch (err) {
      console.error('❌ [STORE] viewMe userApi.whoami() err:', err);
    }
  },

  // eslint-disable-next-line no-empty-pattern
  async deleteUser(id) {
    await userApi.delete(id);
  },
  async logOut({ commit }) {
    console.log('🔍 [STORE] logOut() called');
    console.trace('🔍 [STORE] Call stack for logOut');
    try {
      await userApi.logout();
    } catch (err) {
      // If session already expired, logout API can return 401. Ignore and clear local state.
      console.warn('logout API failed, clear local auth anyway:', err?.response?.status || err);
    }
    let user = null;
    commit('logout', user);
    console.log('✅ [STORE] User logged out successfully');
  }
};

const mutations = {
  setUser(state, user) {
    console.log('🔍 [STORE MUTATION] setUser called with:', user);
    state.user = user;
    
    // ローカルストレージに保存
    if (user) {
      try {
        localStorage.setItem('user', JSON.stringify(user));
        console.log('✅ [STORE MUTATION] User saved to localStorage');
      } catch (error) {
        console.error('❌ [STORE MUTATION] Failed to save user to localStorage:', error);
      }
    } else {
      localStorage.removeItem('user');
      console.log('🗑️ [STORE MUTATION] User removed from localStorage');
    }
  },
  logout(state, user) {
    console.log('🔍 [STORE MUTATION] logout called');
    state.user = user;
    localStorage.removeItem('user');
    console.log('🗑️ [STORE MUTATION] User removed from localStorage on logout');
  },
};

export default {
  state,
  getters,
  actions,
  mutations
};


export class UpdataUserResponse {
  constructor(username, mail_address) {
    this.username = username;
    this.full_name = "";
    this.password = undefined;
    this.mail_address = mail_address;
    this.namespace = "";
    this.openai_api_key = "";
    this.groups = [];
    this.roles = [];
  }
}